// Copie de la dernière visite, gardée dans le navigateur : à l'ouverture, le
// site l'affiche tout de suite, puis la remplace par les vraies données.
// Jamais le texte ni les fichiers d'un message. Effacée à la déconnexion.
// Tout est protégé : un navigateur qui refuse le stockage ne casse rien.
import { COLONNES_MESSAGES_LEGERES } from "./messages";

const PREFIXE = "ip-memoire-v1:";
export const DUREE_MEMOIRE_MS = 7 * 24 * 60 * 60 * 1000;
// Verrou posé par l'effacement (déconnexion) : un chargement qui arrive après
// ne peut pas réécrire la copie. Retiré au démarrage d'un profil.
let verrouille = false;

export function deverrouillerMemoire() { verrouille = false; }
const COLONNES = COLONNES_MESSAGES_LEGERES.split(",").map(s => s.trim());

function stockageParDefaut() {
  try { return window.localStorage; } catch { return null; }
}

export function lireMemoire(uid, { stockage = stockageParDefaut(), maintenant = Date.now() } = {}) {
  if (!uid || !stockage) return null;
  const cle = PREFIXE + uid;
  try {
    const brut = stockage.getItem(cle);
    if (!brut) return null;
    const m = JSON.parse(brut);
    if (!m || typeof m.enregistre !== "number" || maintenant - m.enregistre > DUREE_MEMOIRE_MS) {
      stockage.removeItem(cle);
      return null;
    }
    const res = {};
    if (m.profil) res.profil = m.profil;
    if (Array.isArray(m.commandes)) res.commandes = m.commandes;
    return res;
  } catch {
    try { stockage.removeItem(cle); } catch {}
    return null;
  }
}

export function ecrireMemoire(uid, parties, { stockage = stockageParDefaut(), maintenant = Date.now() } = {}) {
  if (verrouille) return;
  if (!uid || !stockage) return;
  try {
    const avant = lireMemoire(uid, { stockage, maintenant }) || {};
    stockage.setItem(PREFIXE + uid, JSON.stringify({ ...avant, ...parties, enregistre: maintenant }));
  } catch {}
}

export function effacerMemoire({ stockage = stockageParDefaut() } = {}) {
  verrouille = true;
  if (!stockage) return;
  try {
    const cles = [];
    for (let i = 0; i < stockage.length; i++) {
      const k = stockage.key(i);
      if (k && k.startsWith(PREFIXE)) cles.push(k);
    }
    cles.forEach(k => stockage.removeItem(k));
  } catch {}
}

// Liste prête à garder : messages non lus par `nom` seulement, colonnes
// légères seulement ; pas de drapeaux de fil.
export function allegerPourMemoire(commandes, nom) {
  return (commandes || []).map(c => {
    const { messagesComplets, messagesErreur, ...reste } = c;
    const messages = (c.messages || [])
      .filter(m => !nom || (m.auteur !== nom && !(m.lu_par || []).includes(nom)))
      .map(m => Object.fromEntries(COLONNES.filter(k => k in m).map(k => [k, m[k]])));
    return { ...reste, messages };
  });
}
